import {Icon, Typography} from '@ezcater/tapas';
import {IconDefinition} from '@fortawesome/pro-regular-svg-icons';
import {MotionValue, useTransform} from 'motion/react';
import * as motion from 'motion/react-m';
import {twMerge} from 'tailwind-merge';

import useIsMobileCheck from '@/hooks/useIsMobileCheck';

type ValuePropProps = {
  icon: IconDefinition;
  index: number;
  message: string;
  mobileMessage?: string;
  revealProgress: MotionValue<number>;
  total: number;
  reduceMotion: boolean | null;
};

const ValueProp = ({
  icon,
  index,
  message,
  mobileMessage,
  revealProgress,
  total,
  reduceMotion,
}: ValuePropProps) => {
  // Each value prop fades in over its own equal slice of the banner's reveal. Values aren't clamped
  // so they keep changing on scroll. CSS clamps opacity to 0–1 and max() floors y at 0.
  const opacity = useTransform(revealProgress, p => (reduceMotion ? 1 : p * total - index));
  const y = useTransform(revealProgress, p =>
    reduceMotion ? '0px' : `max(0px, ${8 * (1 - (p * total - index))}px)`,
  );
  const isMobile = useIsMobileCheck();

  return (
    <motion.div
      style={{opacity, y}}
      className="flex max-w-28 flex-col items-center gap-1 text-center desktop:max-w-none desktop:flex-row"
    >
      <Icon icon={icon} className="text-green-500" />
      <Typography
        className={twMerge(
          'text-sm font-semibold max-[359px]:w-[83px]', // this width adjustment accounts for screens that are below 360px wide
          index === 0 ? 'max-[359px]:w-[77px]' : '',
        )}
      >
        {isMobile && mobileMessage ? mobileMessage : message}
      </Typography>
    </motion.div>
  );
};

export default ValueProp;
